

import {ChartNoAxesCombined,Cpu, Code, Smartphone, Palette, Globe, Database, Zap } from "lucide-react";
export const services = [
  {
    title: "E-commerce Solutions",
    icon: Globe,
    gradient: "from-blue-500 to-cyan-500",
    points: ["Custom ecommerce website","Shopify","Wordpress","Wix development","Custom ERP software–cloud based"],
  },
  {
    title: "AI Automation & Cloud Services",
    icon: Cpu,
    gradient: "from-green-500 to-teal-500",
    points: ["AI Automation","Chatbot integration","Business Process Automation","Custom AI tools "],
  },
  {
    title: "Data Analytics & Automation",
    icon: ChartNoAxesCombined ,
     gradient: "from-purple-500 to-pink-500",
    points: ["AI enabled Dashboard","PowerBI Dashboards ","SharePoint Development","Smartsheet Development"],
  },
];


export const expertises =  [
  {
    icon: Code,
    title: "Web Development",
    desc: "Custom websites built with modern technologies like React, Vue, and Node.js",
    gradient: "from-blue-500 to-cyan-500",
    points: ["Responsive Design", "SEO Optimized", "Fast Loading", "Secure"],
  },
  {
    icon: Smartphone,
    title: "App Development",
    desc: "Native and cross-platform mobile applications for iOS and Android",
    gradient: "from-purple-500 to-pink-500",
    points: ["Native Performance", "Cross-Platform", "App Store Ready", "Push Notifications"],
  },
  {
    icon: Palette,
    title: "UI/UX Design",
    desc: "Beautiful, intuitive designs that enhance user experience and engagement",
    gradient: "from-green-500 to-teal-500",
    points: ["User Research", "Wireframing", "Prototyping", "Design Systems"],
  },
  {
    icon: Globe,
    title: "E-commerce Solutions",
    desc: "Complete online stores with payment integration and inventory management",
    gradient: "from-orange-500 to-red-500",
    points: ["Payment Gateway", "Inventory System", "Order Management", "Analytics"],
  },
  {
    icon: Database,
    title: "Backend Development",
    desc: "Robust server-side solutions with APIs, databases, and cloud integration",
    gradient: "from-indigo-500 to-purple-500",
    points: ["API Development", "Database Design", "Cloud Hosting", "Security"],
  },
  {
    icon: Zap,
    title: "Performance Optimization",
    desc: "Speed up your existing applications and improve user experience",
    gradient: "from-yellow-500 to-orange-500",
    points: ["Speed Optimization", "Code Review", "Performance Audit", "Monitoring"],
  },
];

